module.exports = __webpack_public_path__ + "87c1db936a4a35d4bbe159bfe4b0288e.png";